import React from 'react';
import { Link } from 'react-router-dom';

const DashboardHeader = ({ onAddVideo }) => {
  return (
    <div className="flex flex-col gap-4 mb-8">
      <h1 className="text-3xl sm:text-4xl font-bold text-white" data-testid="admin-title">
        Admin Dashboard
      </h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        <Link
          to="/admin/youtube-import"
          className="px-4 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition text-center text-sm sm:text-base"
        >
          YouTube Import
        </Link>
        <Link
          to="/admin/artists"
          className="px-4 py-3 bg-yellow-600 hover:bg-yellow-700 text-white font-semibold rounded-lg transition text-center text-sm sm:text-base"
        >
          Artist Management
        </Link>
        <Link
          to="/admin/upload"
          className="px-4 py-3 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-lg transition text-center text-sm sm:text-base"
        >
          Upload Video
        </Link>
        <Link
          to="/admin/live"
          className="px-4 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg transition text-center text-sm sm:text-base"
        >
          Live Stream
        </Link>
        <button
          onClick={onAddVideo}
          className="btn-primary text-sm sm:text-base"
          data-testid="add-video-btn"
        >
          + Add Video
        </button>
      </div>
    </div>
  );
};

export default DashboardHeader;
